import React from "react";

interface SkeletonWrapperProps {
  isLoading: boolean;
  skeleton: React.ReactNode;
  children: React.ReactNode;
}

export const SkeletonWrapper: React.FC<SkeletonWrapperProps> = ({ isLoading, skeleton, children }) => {
  return isLoading ? <>{skeleton}</> : <>{children}</>;
};
